import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const tagListCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-content:flex-start;background:#0000;box-sizing:border-box;display:flex;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;height:auto;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow-y:auto;padding:.25rem;transition:height .25s ease}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}::slotted(wui-tag){margin:0 .75rem .75rem 0}:host([size=md]){max-height:8rem}:host([size=lg]){max-height:15rem}";
const WuiTagListStyle0 = tagListCss;

const WuiTagList$1 = /*@__PURE__*/ proxyCustomElement(class WuiTagList extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = 'md';
    }
    render() {
        return (h(Host, { key: '737a876f12afffe79aba724d04f2f5e372ad2cb6' }, h("div", { key: 'b389c758d551d0edca5ce8dccaf07fc2e2cdb675' }, h("slot", { key: 'c3756777e47b732bc20bc54a5ce55c838bf96856' }))));
    }
    static get style() { return WuiTagListStyle0; }
}, [1, "wui-tag-list", {
        "size": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tag-list"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tag-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTagList$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTagList = WuiTagList$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTagList, defineCustomElement };

//# sourceMappingURL=wui-tag-list.js.map